/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode, useCallback, useRef } from "react";
import { AgGridReact, AgGridReactProps } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./index.css";
import { Checkbox, Pagination } from "@abb/abb-common-ux-react";
type RowData = {
  [key: string]: any;
};
type ColumnDefinition = {
  field: string;
  flex?: number;
  type?: string;
  link?: string;
  isExternalLink?: boolean;
  cellStyle?: { [key: string]: string };
  pinned?: boolean;
  filter?: boolean;
  editable?: boolean;
  [key: string]: any;
};
interface TableProps extends AgGridReactProps {
  rowData: RowData[] | any[];
  columns: ColumnDefinition[];
  theme?: "light" | "dark";
  defaultColDef?: any;
  isPagination?: boolean;
  paginationPageSize?: number;
  autoGroupColumnDef?: any;
  enableCellEditingOnBackspace?: boolean;
  suppressRowClickSelection?: boolean;
  groupSelectsChildren?: boolean;
  debug?: boolean;
  rowClassRules?: { [className: string]: (params: any) => boolean };
  rowSelection?: "single" | "multiple" | undefined;
  rowGroupPanelShow?: "always" | "onlyWhenGrouping" | "never" | undefined;
  pivotPanelShow?: "always" | "never" | "onlyWhenPivoting" | undefined;
  enableRangeSelection?: boolean;
  onGridReady?: (params: any) => void;
  isExportRequired?: boolean;
  exportLabel?: ReactNode | string;
  exportBtnPosition?: "start" | "center" | "end";
  rowClass?: string;
  getRowClass?: (params: any) => string | string[];
  noRowsMessage? : string|ReactNode,
  paginationConfig?: {
    pageSize: number;
    pageNumber: number;
    totalRecords: number;
    showPageSelectionInput?: boolean;
    pageSizeOptions?: number[];
    onPageClick: (val: any) => void;
  };
}

const MyPnPDataGrid = (props: TableProps) => {
  const gridRef = useRef<any>();
  const {
    rowSelection = "single",
    rowData,
    rowClass,
    getRowClass,
    exportBtnPosition = "end",
    exportLabel,
    noRowsMessage="No Data Found",
    ...restProps
  } = props;


  const DataLinkRenderer = (params: any) => {
    const link = params.data[params.colDef.link]
      ? params.data[params.colDef.link]
      : "#";
    const target = params.colDef.isExternalLink ? "_blank" : "_self";

    return (
      <a
        href={link}
        target={target}
        rel={params.colDef.isExternalLink ? "noopener noreferrer" : ""}
      >
        {params.value}
      </a>
    );
  };

  const CheckBoxRenderer = (params: any) => {
    return (
      <Checkbox sizeClass="small" value={params.value} data={!params.value} />
    );
  };

  const exportData = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);
  const renderType = (type: string) => {
    switch (type) {
      case "dataLink":
        return {
          cellRenderer: DataLinkRenderer,
        };
      case "checkbox":
        return {
          cellRenderer: CheckBoxRenderer,
        };
      default:
        return;
    }
  };
  const columnsData = props.columns.map((column: any) => {
    let updatedColumn = { ...column };
    if (column.type) {
      updatedColumn = { ...updatedColumn, ...renderType(column.type) };
    }
    if (column.flex) {
      updatedColumn = { ...updatedColumn, flex: column?.flex || 1 };
    }
    return updatedColumn;
  });



  return (
    <div className="table-width">
      {props.isExportRequired && (
        <div
          style={{
            display: "flex",
            justifyContent: exportBtnPosition,
          }}
        >
          <div className="export-btn" onClick={exportData}>
            {exportLabel ? exportLabel : "Export as CSV"}
          </div>
        </div>
      )}
      <div
        className={
          props.theme === "dark" ? "ag-theme-quartz-dark" : "ag-theme-quartz"
        }
      >
        <AgGridReact
          className="myclass"
          rowClass={rowClass}
          getRowClass={getRowClass}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnsData}
          defaultColDef={props.defaultColDef}
          paginationPageSize={props.paginationPageSize}
          autoGroupColumnDef={props.autoGroupColumnDef}
          enableCellEditingOnBackspace={props.enableCellEditingOnBackspace}
          suppressRowClickSelection={props.suppressRowClickSelection}
          groupSelectsChildren={props.groupSelectsChildren}
          debug={props.debug}
          rowSelection={rowSelection}
          noRowsOverlayComponent={() => noRowsMessage}
          rowClassRules={props.rowClassRules}
          rowGroupPanelShow={props.rowGroupPanelShow}
          pivotPanelShow={props.pivotPanelShow}
          enableRangeSelection={props.enableRangeSelection}
          onGridReady={props.onGridReady}
          domLayout="autoHeight"
          {...restProps}
        />
      </div>
      {props.isPagination && props.paginationConfig && (
        <div className="abb-pagination">
          <Pagination
            showPageSelectionInput={
              props.paginationConfig.showPageSelectionInput
            }
            onGotoPage={(val) => props.paginationConfig!.onPageClick(val)}
            currentPage={props.paginationConfig.pageNumber - 1}
            currentPageSize={props.paginationConfig.pageSize}
            rowCount={props.paginationConfig.totalRecords}
            showPrevNext={true}
            showNumberButtons={true}
            pageSizeOptions={props.paginationConfig.pageSizeOptions}
          />
        </div>
      )}
    </div>
  );
};
export default MyPnPDataGrid;
